// extracted by mini-css-extract-plugin
export default {"slider":"styles_slider__qXSnK","inner":"styles_inner__NVzck","sliderNav":"styles_sliderNav__EZh5t"};